@use "../../sass/variables/animation";
@use "../../sass/variables/colors";
@use "../../sass/mixins/font-family";

:host {
    a {
        @include font-family.font(light);

        background: none;
        border: 0;
        color: colors.$color-gray-text;
        cursor: pointer;
        outline: 0;
        text-decoration: underline;
        transition: color 500ms ease;

        &:hover {
            color: colors.$color-black-text;

            .ux-icon[name="arrow-small-right"] {
                transform: translateX(5px);
            }
        }
    }

}

:host([variant='primary']) {
    a {
        color: colors.$theme-color-primary;
        text-decoration: none;
    }

}

:host([variant='current']) {
    a {
        color: currentColor;
        text-decoration: underline;
    }

}

:host([strong]) {
    a {
        @include font-family.font(bold);
    }

}

.ux-icon {
    margin: 0 0.3em;
    transition: transform animation.$animationSpeed-fast;
}

.ux-icon__svg {
    fill: currentcolor;
}